import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram } from "lucide-react";
import { WA_LINK } from "@/data";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/hcc2ecna_change_the_logo_202604131845.png"
                alt="Raj Muscle Care Studio"
                className="h-[72px] sm:h-[120px] w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-2">
              Exclusive Massage Therapy for Men in Mumbai
            </p>
            <p className="text-[#FF4500] text-xs font-semibold mb-5 font-inter tracking-wide">
              15 mins from Mumbai Airport
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://g.co/kgs/n3rSyxM"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#FF4500] transition-colors text-xs font-semibold border border-white/20 px-3 py-1.5 rounded-full hover:border-[#FF4500]/50"
                data-testid="footer-google-link"
              >
                Google
              </a>
              <a
                href="https://jsdl.in/RSL-ELD1776084352"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#FF4500] transition-colors text-xs font-semibold border border-white/20 px-3 py-1.5 rounded-full hover:border-[#FF4500]/50"
                data-testid="footer-justdial-link"
              >
                JustDial
              </a>
              <a
                href="https://www.instagram.com/musclecarestudio/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#FF4500] transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-xs font-semibold uppercase tracking-[0.2em] mb-5 font-inter">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { path: "/", label: "Home" },
                { path: "/about", label: "About" },
                { path: "/services", label: "Services" },
                { path: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-gray-400 hover:text-[#FF4500] text-sm transition-colors font-inter"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h4 className="text-white text-xs font-semibold uppercase tracking-[0.2em] mb-5 font-inter">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex gap-3 text-sm text-gray-400">
                <MapPin size={15} className="text-[#FF4500] mt-0.5 shrink-0" />
                <span className="font-inter">
                  Shop No. 1B, Venus Tower, Behind Axis Bank, Veera Desai Road, Andheri West, Mumbai — 400053
                </span>
              </div>
              <a
                href="tel:+919004250500"
                className="flex items-center gap-3 text-sm text-gray-400 hover:text-[#FF4500] transition-colors font-inter"
                data-testid="footer-phone-link"
              >
                <Phone size={15} className="text-[#FF4500] shrink-0" />
                +91 90042 50500
              </a>
              <a
                href="mailto:jraj06272@gmail.com"
                className="flex items-center gap-3 text-sm text-gray-400 hover:text-[#FF4500] transition-colors font-inter"
                data-testid="footer-email-link"
              >
                <Mail size={15} className="text-[#FF4500] shrink-0" />
                jraj06272@gmail.com
              </a>
              <div className="flex gap-3 text-sm text-gray-400 font-inter">
                <Clock size={15} className="text-[#FF4500] mt-0.5 shrink-0" />
                8:00 AM – 11:30 PM, All Days &nbsp;|&nbsp; Late night hotel service on request
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs text-center font-inter">
            100% Discreet &amp; Confidential Massage Service in Mumbai
          </p>
          <p className="text-gray-500 text-xs text-center font-inter">
            © 2025 Raj Muscle Care Studio. All Rights Reserved. &nbsp;|&nbsp; Developed by{" "}
            <a
              href="https://buffetism.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF4500] hover:underline"
            >
              BUFFETISM IT VENTURES
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
